export default {
  Legendary: 'text-pink-500',
  Epic: 'text-green-500',
  Rare: 'text-blue-500',
  Unusual: 'text-yellow-500',
  Uncommon: 'text-gray-600',
}